import { CountUp } from 'countup.js';

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('span[class*="stat-value"]').forEach((ele) => {
    const options = {
      decimalPlaces: 0,
      duration: 1,
    };

    const countupStrings = ele.className.split(' ').filter((cn) => cn.startsWith('countup'));
    if (countupStrings.length > 0) {
      const decimalPlaces = Number(countupStrings[0].split('-')[1]);
      if (!Number.isNaN(decimalPlaces)) {
        options.decimalPlaces = decimalPlaces;
      }
    }

    const value = ele.innerHTML;
    const numericValue = Number(value);

    if (!Number.isNaN(numericValue)) {
      const countUp = new CountUp(ele, value, options);
      if (!countUp.error) {
        countUp.start();
      } else {
        console.error(countUp.error);
      }
    }
  });

  console.log('Widget Counters loaded!');
});
